import { render, staticRenderFns } from "./JDDirectInvestmentStepLayout.vue?vue&type=template&id=28005b17&scoped=true&"
import script from "./JDDirectInvestmentStepLayout.vue?vue&type=script&lang=js&"
export * from "./JDDirectInvestmentStepLayout.vue?vue&type=script&lang=js&"
import style0 from "./JDDirectInvestmentStepLayout.vue?vue&type=style&index=0&id=28005b17&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28005b17",
  null
  
)

export default component.exports